import request from '../../../../util/request';

export function uploadImgRequest(file, fileName, callback) {
    let formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName);
    return request(
        '/upload',
        {
            method: 'POST',
            body: formData,
        },
        callback
    );
}

export function createBotRequest(
    space_id,
    name,
    description,
    icon_file_id,
    prompt,
    prologue,
    suggested_questions,
    callback
) {
    return request(
        '/cBot',
        {
            method: 'POST',
            body: {
                space_id,
                name,
                description,
                icon_file_id,
                prompt,
                prologue,
                suggested_questions,
            },
        },
        callback
    );
}



//创建知识库文件接口
export function createKcsFileList(data, callback) {
    return request(
        '/zhishiku/createDatasetsFile',
        {
            method: 'POST',
            body: data,
        },
        callback
    );
}
